import createApp from '@shopify/app-bridge';
import { getSessionToken } from "@shopify/app-bridge-utils";

const urlSearchParams = new URLSearchParams(window.location.search);
const params = Object.fromEntries(urlSearchParams.entries());
// Dev fallback shop, used ONLY when opening the app standalone (e.g. localhost
// without a ?shop= param). In Shopify admin the real ?shop= is always present.
// Set this to a store that exists in your DB so local dev can authenticate.
const shop_name = params?.shop ? params?.shop : 'tarun-test-ysmgstnb.myshopify.com'
const embedded = params?.embedded ? 1 : 0;
const shop_url = window?.__st?.pageurl ? window?.__st?.pageurl : '';
/* below config variable is use for Shopify app bridge */
const config = { apiKey: process.env.API_KEY, host: params.host, forceRedirect: true };/*params.host*/
const admin_apiEndpoint = process.env.admin_apiEndpoint;
const client_apiEndpoint = process.env.client_apiEndpoint;
const domain = process.env.domain;
const mode = process.env.MODE;
const config_variable = { config, shop_name, embedded, shop_url };
let BridgeApp = {};
let sessionToken = '12311';
// Initialise App Bridge whenever the app is embedded (a `host` is present).
// This covers BOTH a production build and a local/dev build opened inside
// Shopify admin, so the sidebar navigation works in either case. When running
// truly standalone (no host) we skip it and fall back to the local menu.
if (config_variable?.config?.host) {
  try {
    BridgeApp = createApp({ apiKey: config_variable?.config?.apiKey, host: config_variable?.config?.host });
    sessionToken = await getSessionToken(BridgeApp);
  } catch (e) {
    console.warn('App Bridge init failed:', e);
  }
}

export {
  admin_apiEndpoint,
  client_apiEndpoint,
  config_variable,
  domain,
  mode,
  BridgeApp,
  sessionToken
}
